module.exports = __webpack_public_path__ + "img/lock-unlock.8af7b0bb.svg";